import asyncWait from "../../functions/asyncWait";
import runNetworkPingTest from "./runNetworkPingTest";

export default function networkPingTestController(){

    const AUTO_RETRY_LIMIT = 1
    const WAIT_BETWEEN_RETRY = 3000
    let currentRetryCount = 0

    const runTest = async () => {
        try{
            return await runNetworkPingTest()
        }catch(err){
            if(currentRetryCount < AUTO_RETRY_LIMIT){
                return retry()
            }else{
                throw(err)
            }
        }
    }

    const retry = async () => {
        currentRetryCount++
        await asyncWait(WAIT_BETWEEN_RETRY)
        return await runTest()
    }

    return {
        runTest,
        currentRetryCount
    }
}